export const SITE_CONTENT = {
  logoText: 'La Luna Que Ladra',
  tagline: 'Poesía, intuición y magia de lo invisible',
  sobreMi: {
    title: 'Sobre Mí',
    bio: 'La Luna Que Ladra es seudónimo de Susy M.C., Escritora, Poeta oral, Psicóloga y Tallerista. Es un alma inquieta que acostumbra a embarcarse en varios proyectos a la vez. Sus poemas son la intersección entre la exploración emocional, la espiritualidad y el lenguaje poético. Desde el 2019 ha llevado su poesía a los escenarios de micrófonos abiertos en Perú, Argentina y España, consolidando un estilo directo, emocional y cercano. Ha participado en Slams de Poesía y en la Cruzada Poética, junto a Oliver Kozlov y Beverly Hells, consolidando su presencia dentro de la escena poética contemporánea. También ha formado parte de diversas antologías poéticas colectivas en Madrid, España junto a Versándonos, entre ellas: Habrá poesía (2025), Cara a cara (2025), Camino hacia el amor (2026) y Efemérides (2026).'
  },
  libro: {
    title: 'Compra Mi Libro',
    bookName: 'Troquelada',
    subtitle: 'Un viaje poético por la memoria, el cuerpo y el alma. Un poemario oracular',
    editions: [
      {
        id: 'ebook',
        title: 'E-book',
        subtitle: 'Descarga digital instantánea',
        features: ['Descarga inmediata'],
        cta: 'Comprar E-book',
        url: 'https://www.amazon.com/dp/B0GX2XB5HV/?tag=lalunaqueladr-20',
        featured: false,
        badge: null
      },
      {
        id: 'tapa-blanda',
        title: 'Tapa Blanda',
        subtitle: 'Envío a todo el mundo',
        features: ['Edición ligera'],
        cta: 'Comprar Tapa Blanda',
        url: 'https://www.amazon.com/dp/B0GY9B8QY9/?tag=lalunaqueladr-20',
        featured: true,
        badge: 'Popular'
      },
      {
        id: 'troquelada',
        title: 'Tapa Dura',
        subtitle: 'Envío a todo el mundo',
        features: ['Edición premium coleccionable', 'Recomendado para usar como oráculo'],
        cta: 'Comprar Tapa Dura',
        url: 'https://www.amazon.com/dp/B0GY91ZJNP/?tag=lalunaqueladr-20',
        featured: false,
        badge: null
      }
    ]
  },
  tarot: {
    title: 'Lectura de Tarot',
    description: 'Concéntrate en tu pregunta, respira profundo y elige 3 cartas para recibir tu mensaje.',
    resetLabel: 'Nueva Lectura'
  },
  contacto: {
    title: 'Contáctame',
    description: 'Un espacio para ti. Escríbeme y mi respuesta llegará.',
    subjects: ['Lectura de Tarot', 'Sobre el Libro', 'Colaboración', 'Otro']
  },
  footer: 'La Luna Que Ladra'
};
